import styled from '@emotion/styled';
import { Paper, TableCell, TableRow } from '@mui/material';

export const TableRoot = styled(Paper)({
  padding: 0,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
});

export const ScrollArea = styled.div({
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  borderRadius: '12px',
  border: '1px solid rgba(15, 23, 42, 0.08)',
});

export const StickyHeadCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  background: '#f8fafc',
  fontWeight: 600,
  color: theme.palette.text.primary,
  zIndex: 1,
}));

export const ClickableRow = styled(TableRow)({
  cursor: 'pointer',
  '&:hover': {
    background: '#f1f5f9',
  },
  '& > .MuiTableCell-root': {
    background: 'inherit',
  },
});

export const TableEmpty = styled.div(({ theme }) => ({
  padding: '2rem 1rem',
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
